import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import { useLocale } from '../../../../hooks/useLocale';
import { LOAN_DURATION_OPTIONS_DE } from '../../../GetStarted/GetStartedDE/loanOptions';
import { TMobileSignupForm } from '../../form/form';
import { useMobileSignupNavContext } from '../../hooks/useMobileSignupNavContext';
import { OptionCards, TOption } from '../../OptionCards/OptionCards';
import { StepLayout } from '../../StepLayout/StepLayout';

type TDuration = (typeof LOAN_DURATION_OPTIONS_DE)[number]['value'];

const DURATION_ICONS: Record<TDuration, string> = {
  few_months: '⏱️',
  one_to_two_years: '📅',
  three_plus_years: '🗓️',
  ongoing: '🔄',
};

// DIT-709. Card picker — selecting a card advances (no CTA).
// Reads/writes the shared mobile signup form store (DIT-664).
export const DurationScreen = () => {
  const { t } = useLingui();
  const { i18n } = useLocale();
  const { watch, setValue } = useFormContext<TMobileSignupForm>();
  const { goNext } = useMobileSignupNavContext();

  const loanDuration = watch('loanDuration');

  const options: TOption<TDuration>[] = LOAN_DURATION_OPTIONS_DE.map(
    (option) => ({
      value: option.value,
      icon: DURATION_ICONS[option.value],
      label: i18n._(option.label),
    }),
  );

  return (
    <StepLayout
      stageTitle={t`Credit request`}
      heading={t`How long do you need the loan for?`}
      hideCta
    >
      <OptionCards
        name="duration"
        options={options}
        value={loanDuration || undefined}
        onChange={(value) => {
          setValue('loanDuration', value, { shouldDirty: true });
          goNext();
        }}
      />
    </StepLayout>
  );
};
